// // src/pages/InvoicePage.jsx
// import signatureImage from '../assets/signn-removebg-preview.png';
// import React, { useState, useEffect } from 'react';
// import { useParams, useNavigate, useLocation } from 'react-router-dom';
// import { 
//   FiArrowLeft, 
//   FiDownload, 
//   FiSend, 
//   FiPrinter, 
//   FiCheck, 
//   FiX,
//   FiShoppingBag, 
//   FiMapPin, 
//   FiPhone, 
//   FiMail,
//   FiCalendar,
//   FiFileText
// } from 'react-icons/fi';
// import { orderAPI } from '../services/api';
// import jsPDF from 'jspdf';
// import html2canvas from 'html2canvas';

// const InvoicePage = () => {
//   const { orderId } = useParams();
//   console.log("l'id de la commande est", orderId);
//   const navigate = useNavigate();
//   const location = useLocation();

//   // Récupérer le paramètre newLivre depuis l'URL
//   const queryParams = new URLSearchParams(location.search);
//   console.log("recuperation de la requette")
//   console.log(queryParams);
//   const newLivre = queryParams.get('newLivre');
//   console.log("voici le prix de la livraison")
//   console.log(newLivre);
  
//   const [order, setOrder] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState('');
//   const [generatingPDF, setGeneratingPDF] = useState(false);
//   const [showWhatsAppForm, setShowWhatsAppForm] = useState(false);
//   const [whatsappNumber, setWhatsappNumber] = useState('');
//   const [sendingWhatsApp, setSendingWhatsApp] = useState(false);

//   // Récupérer les détails de la commande
//   useEffect(() => {
//     const fetchOrderDetails = async () => {
//       try {
//         setLoading(true);
//         const response = await orderAPI.getMyOrders(orderId);
        
//         if (response.data && response.data.success) {
//           const orderData = response.data.data;
          
//           const formattedOrder = {
//             id: orderData.id,
//             order_numero: orderData.order_number || `CMD-${orderData.id}`,
//             user_id: orderData.user_id,
//             receiver_name: orderData.recipient_name || orderData.shipping_name,
//             receiver_phone: orderData.recipient_phone || orderData.shipping_phone,
//             receiver_email: orderData.recipient_email || orderData.user?.email,
//             receiver_address: orderData.recipient_address || orderData.shipping_address,
//             receiver_city: orderData.recipient_city || orderData.shipping_city,
//             receiver_country: orderData.recipient_country || orderData.shipping_country,
//             status: orderData.status,
//             total_amount: orderData.total_amount || 0,
//             created_at: orderData.created_at || new Date().toISOString(),
//             updated_at: orderData.updated_at || new Date().toISOString(),
//             items: orderData.items || orderData.order_items || []
//           };
          
//           setOrder(formattedOrder);
          
//           if (formattedOrder.receiver_phone) {
//             setWhatsappNumber(formattedOrder.receiver_phone);
//           }
//         } else {
//           setError('Commande non trouvée');
//         }
//       } catch (err) {
//         console.error('Erreur lors du chargement de la commande:', err);
//         setError('Impossible de charger les détails de la commande');
//       } finally {
//         setLoading(false);
//       }
//     };

//     if (orderId) {
//       fetchOrderDetails();
//     }
//   }, [orderId]);

//   // Formatage des données pour la facture
//   const getInvoiceData = () => {
//     if (!order) return null;
    
//     return {
//       header: {
//         logo: 'StelonneMarket',
//         title: 'FACTURE',
//         invoiceNumber: order.order_numero || `CMD-${order.id}`,
//         date: new Date(order.created_at).toLocaleDateString('fr-FR', {
//           day: '2-digit',
//           month: 'long',
//           year: 'numeric'
//         }),
//         dueDate: new Date(order.updated_at).toLocaleDateString('fr-FR', {
//           day: '2-digit',
//           month: 'long',
//           year: 'numeric'
//         })
//       },
//       company: {
//         name: 'STELONE MARKET SARL',
//         address: 'Commissariat 14e, Ndogpassi II',
//         city: 'Douala, Cameroun',
//         phone: '+237 (680 219 057 / 655 996 918) ',
//         email: 'contact@stelonne-market.online',
//         url: 'www.stelonne-market.online',
//         // rccm: 'RCCM-DLA-2024-XXXX',
//         nui: 'P019318559728M'
//       },
//       client: {
//         name: order.receiver_name || 'Client',
//         phone: order.receiver_phone,
//         email: order.receiver_email,
//         address: order.receiver_address,
//         city: `${order.receiver_city || ''}${order.receiver_city && order.receiver_country ? ', ' : ''}${order.receiver_country || ''}`,
//         clientId: `CLT-${order.user_id || '000'}`
//       },
//       summary: {
//         subtotal: order.total_amount,
//         tax: 0,
//         shipping: newLivre ? parseFloat(newLivre) : 5000,
//         total: parseInt(order.total_amount) + (newLivre ? parseInt(newLivre) : 5000),
//         currency: 'FCFA',
//         paymentMethod: 'Cash on Delivery',
//         paymentStatus: order.status === 'completed' ? 'Payé' : 'En attente'
//       }
//     };
//   };

//   // Formater le montant
//   const formatAmount = (amount) => {
//     return new Intl.NumberFormat('fr-FR').format(amount);
//   };

//   // Générer le PDF
//   const generatePDF = async () => {
//     if (!order) return;
    
//     setGeneratingPDF(true);
//     try {
//       const invoiceElement = document.getElementById('invoice-to-print');
      
//       if (!invoiceElement) {
//         throw new Error('Élément de facture non trouvé');
//       }

//       // === NOUVEAU CODE : Cloner et traiter les images ===
//       const clone = invoiceElement.cloneNode(true);
      
//       // Fonction pour appliquer le filtre à la signature
//       const processSignatureImage = async () => {
//         const signatureImg = clone.querySelector('img[alt="Signature directrice"]');
        
//         if (!signatureImg || !signatureImg.src) return;
        
//         return new Promise((resolve) => {
//           const tempImg = new Image();
//           tempImg.crossOrigin = "anonymous";
          
//           tempImg.onload = () => {
//             // Créer un canvas pour appliquer le filtre
//             const tempCanvas = document.createElement('canvas');
//             const ctx = tempCanvas.getContext('2d');
            
//             tempCanvas.width = tempImg.width;
//             tempCanvas.height = tempImg.height;
            
//             // Appliquer le filtre noir
//             ctx.filter = 'grayscale(100%) brightness(0.15) contrast(1.8)';
//             ctx.drawImage(tempImg, 0, 0);
            
//             // Remplacer la source de l'image dans le clone
//             signatureImg.src = tempCanvas.toDataURL('image/png');
//             signatureImg.style.filter = 'none'; // Retirer le filtre CSS
            
//             resolve();
//           };
          
//           tempImg.onerror = () => {
//             console.warn('Erreur de chargement de la signature');
//             resolve();
//           };
          
//           tempImg.src = signatureImg.src;
//         });
//       };
      
//       // Appliquer le traitement à la signature
//       await processSignatureImage();
      
//       // Ajouter le clone temporairement au DOM
//       clone.style.position = 'absolute';
//       clone.style.left = '-9999px';
//       clone.style.top = '0';
//       document.body.appendChild(clone);
      
//       // Dimensions A4
//       const PDF_WIDTH = 210; // mm
//       const PDF_HEIGHT = 297; // mm
//       const MARGIN = 10; // mm sur chaque côté
//       const USABLE_HEIGHT = PDF_HEIGHT - (2 * MARGIN);

//       // D'abord essayer avec l'échelle normale
//       let scale = 2;
//       let canvas = await html2canvas(clone, { // Utiliser le clone au lieu de l'original
//         scale: scale,
//         useCORS: true,
//         backgroundColor: '#ffffff',
//         width: clone.scrollWidth,
//         height: clone.scrollHeight,
//         onclone: (clonedDoc) => {
//           // S'assurer que les styles sont conservés
//           const clonedSignature = clonedDoc.querySelector('img[alt="Signature directrice"]');
//           if (clonedSignature && clonedSignature.style.filter === 'none') {
//             clonedSignature.style.filter = 'grayscale(100%) brightness(0.15) contrast(1.8)';
//           }
//         }
//       });

//       // Nettoyer : retirer le clone du DOM
//       document.body.removeChild(clone);

//       // Calculer la hauteur en mm
//       const imgHeightMm = (canvas.height * (PDF_WIDTH - 2 * MARGIN)) / canvas.width;
      
//       // Si le contenu dépasse légèrement (moins de 20mm)
//       const OVERFLOW_THRESHOLD = 20; // mm
//       if (imgHeightMm > USABLE_HEIGHT && imgHeightMm <= USABLE_HEIGHT + OVERFLOW_THRESHOLD) {
//         // Réduire légèrement l'échelle pour tout faire tenir sur une page
//         const compressionRatio = USABLE_HEIGHT / imgHeightMm;
//         scale = scale * compressionRatio * 0.95; // 95% pour une marge
        
//         // Regénérer le canvas avec la nouvelle échelle
//         canvas = await html2canvas(clone, {
//           scale: scale,
//           useCORS: true,
//           backgroundColor: '#ffffff',
//           width: clone.scrollWidth,
//           height: clone.scrollHeight
//         });
//       }

//       const imgData = canvas.toDataURL('image/png');
//       const pdf = new jsPDF({
//         orientation: 'portrait',
//         unit: 'mm',
//         format: 'a4'
//       });

//       const imgWidth = PDF_WIDTH - 2 * MARGIN;
//       const imgHeight = (canvas.height * imgWidth) / canvas.width;
//       const xPos = MARGIN;
//       const yPos = MARGIN;

//       // Vérifier si besoin de plusieurs pages après compression
//       if (imgHeight <= USABLE_HEIGHT) {
//         // Tout tient sur une page
//         pdf.addImage(imgData, 'PNG', xPos, yPos, imgWidth, imgHeight);
//       } else {
//         // Nécessite plusieurs pages
//         let currentY = 0;
//         let pageNum = 0;
        
//         while (currentY < imgHeight) {
//           if (currentY > 0) {
//             pdf.addPage();
//             pageNum++;
//           }
          
//           const sliceHeight = Math.min(USABLE_HEIGHT, imgHeight - currentY);
          
//           // Créer un canvas pour la tranche
//           const sliceCanvas = document.createElement('canvas');
//           const sliceCtx = sliceCanvas.getContext('2d');
//           const sliceYCanvas = (currentY / imgHeight) * canvas.height;
//           const sliceHeightCanvas = (sliceHeight / imgHeight) * canvas.height;
          
//           sliceCanvas.width = canvas.width;
//           sliceCanvas.height = sliceHeightCanvas;
          
//           sliceCtx.drawImage(
//             canvas,
//             0, sliceYCanvas, canvas.width, sliceHeightCanvas,
//             0, 0, canvas.width, sliceHeightCanvas
//           );
          
//           const sliceData = sliceCanvas.toDataURL('image/png');
//           pdf.addImage(sliceData, 'PNG', xPos, yPos, imgWidth, sliceHeight);
          
//           // Pied de page
//           pdf.setFontSize(8);
//           pdf.setTextColor(150);
//           pdf.text(
//             `Page ${pageNum + 1} - Facture ${order.order_numero}`,
//             PDF_WIDTH / 2,
//             PDF_HEIGHT - 5,
//             { align: 'center' }
//           );
          
//           currentY += sliceHeight;
//         }
//       }

//       const fileName = `Facture_${order.order_numero}_${new Date().toISOString().split('T')[0]}.pdf`;
//       pdf.save(fileName);
      
//     } catch (error) {
//       console.error('Erreur génération PDF:', error);
//       alert('Erreur lors de la génération du PDF');
//     } finally {
//       setGeneratingPDF(false);
//     }
//   };

//   // Envoyer par WhatsApp
//   const sendViaWhatsApp = () => {
//     if (!whatsappNumber.trim()) {
//       alert('Veuillez entrer un numéro WhatsApp valide');
//       return;
//     }

//     const formattedNumber = whatsappNumber
//       .replace(/\s+/g, '')
//       .replace('+', '')
//       .replace(/^0/, '237');

//     const message = encodeURIComponent(
//       `Bonjour ${order.receiver_name},\n\nVotre facture pour la commande ${order.order_numero} est prête.\nMontant total: ${order.total_amount.toLocaleString()} FCFA\n\nMerci pour votre confiance !\n\nStellone Market`
//     );

//     const whatsappURL = `https://wa.me/${formattedNumber}?text=${message}`;
    
//     window.open(whatsappURL, '_blank');
    
//     setSendingWhatsApp(true);
//     setTimeout(() => {
//       setSendingWhatsApp(false);
//       setShowWhatsAppForm(false);
//       alert('Message WhatsApp préparé ! Ouvrez WhatsApp pour envoyer.');
//     }, 1500);
//   };

//   // Imprimer la facture
//   const printInvoice = () => {
//     const invoiceElement = document.getElementById('invoice-to-print');
    
//     if (!invoiceElement) return;
    
//     const printWindow = window.open('', '_blank');
//     printWindow.document.write(`
//       <!DOCTYPE html>
//       <html>
//         <head>
//           <title>Facture ${order.order_numero}</title>
//           <style>
//             @page {
//               margin: 10mm;
//             }
//             body {
//               margin: 0;
//               padding: 0;
//             }
//           </style>
//         </head>
//         <body>
//           ${invoiceElement.outerHTML}
//         </body>
//       </html>
//     `);
    
//     printWindow.document.close();
    
//     setTimeout(() => {
//       printWindow.focus();
//       printWindow.print();
//       printWindow.close();
//     }, 300);
//   };

//   // Composant de facture
//   const InvoiceContent = ({ order }) => {
//     const invoiceData = getInvoiceData();
    
//     if (!invoiceData) return null;
    
//     return (
//       <div 
//         id="invoice-to-print" 
//         className="bg-white shadow-2xl overflow-hidden relative mx-auto"
//         style={{
//           width: '210mm',
//           minHeight: '297mm',
//           boxSizing: 'border-box'
//         }}
//       >
//         {/* Filigrane "STELLONE MARKET" sur l'autre diagonale (de haut droit à bas gauche) - STATIQUE */}
//         <div className="absolute inset-0 overflow-hidden pointer-events-none z-0">
//           <div 
//             className="absolute w-[150%]"
//             style={{
//               top: '-7%',
//               right: '0',
//               transform: 'rotate(-45deg) translateX(30%) translateY(-50%)',
//               transformOrigin: 'top right',
//             }}
//           >
//             <div 
//               className="text-yellow-300/20 font-bold whitespace-nowrap tracking-wider"
//               style={{
//                 fontSize: '70px', // Taille réduite pour que tout tienne dans la page
//                 lineHeight: '1',
//                 textShadow: '2px 2px 4px rgba(0,0,0,0.1)',
//                 letterSpacing: '10px',
//               }}
//             >
//               STELONNE
//             </div>
//           </div>
          
//           {/* Deuxième occurrence pour couvrir toute la diagonale */}
//           <div 
//             className="absolute w-[150%]"
//             style={{
//               top: '34%',
//               right: '-9%',
//               transform: 'rotate(-45deg) translateX(30%) translateY(-50%)',
//               transformOrigin: 'top right',
//             }}
//           >
//             <div 
//               className="text-yellow-300/20 font-bold whitespace-nowrap tracking-wider"
//               style={{
//                 fontSize: '70px',
//                 lineHeight: '1',
//                 textShadow: '2px 2px 4px rgba(0,0,0,0.1)',
//                 letterSpacing: '10px',
//               }}
//             >
//               MARKET
//             </div>
//           </div>
//         </div>

//         <div className="p-1 relative z-10 flex flex-col" style={{ 
//           boxSizing: 'border-box',
//           minHeight: '297mm'
//         }}>
          
//           {/* En-tête de la facture */}
//           <div className="bg-gradient-to-r from-yellow-400 to-yellow-400 p-4 text-white rounded-lg mb-6">
//             <div className="flex justify-between items-start">
//               <div className="flex items-center space-x-3">
//                 <div className="bg-white text-yellow-600 p-2 rounded-lg">
//                   <FiShoppingBag className="text-2xl" />
//                 </div>
//                 <div>
//                   <h1 className="text-2xl font-bold leading-tight">STELONNE MARKET</h1>
//                   <p className="text-yellow-100 text-sm mt-1">Decouvrez & Achetez & Profitez</p>
//                 </div>
//               </div>
              
//               <div className="text-right bg-gray-400/100 p-3 rounded-lg">
//                 <h2 className="text-xl font-bold text-white mb-1">FACTURE</h2>
//                 <p className="text-yellow-100 text-sm">N° {invoiceData.header.invoiceNumber}</p>
//               </div>
//             </div>
//           </div>

//           {/* Informations entreprise et client */}
//           <div className="grid grid-cols-2 gap-6 mb-6">
//             {/* Informations entreprise */}
//             <div className="space-y-2">
//               <h3 className="text-base font-bold text-gray-800 flex items-center">
//                 <FiShoppingBag className="mr-2 text-yellow-500" />
//                 Émetteur
//               </h3>
//               <div className="space-y-1 text-sm">
//                 <p className="font-semibold text-gray-800">{invoiceData.company.name}</p>
//                 <p className="text-gray-600 flex items-start">
//                   <FiMapPin className="mr-2 text-gray-400 mt-0.5 flex-shrink-0" />
//                   <span>{invoiceData.company.address}</span>
//                 </p>
//                 <p className="text-gray-600 ml-6">{invoiceData.company.city}</p>
//                 <p className="text-gray-600 flex items-center">
//                   <FiPhone className="mr-2 text-gray-400 flex-shrink-0" />
//                   {invoiceData.company.phone}
//                 </p>
//                 <p className="text-gray-600 flex items-center">
//                   <FiMail className="mr-2 text-gray-400 flex-shrink-0" />
//                   {invoiceData.company.email}
//                 </p>
//                 <div className="flex space-x-2 mt-1 ml-6">
//                   {/* <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded">
//                     {invoiceData.company.rccm}
//                   </span> */}
//                   <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded">
//                     {invoiceData.company.nui}
//                   </span>
//                 </div>
//               </div>
//             </div>

//             {/* Informations client */}
//             <div className="space-y-2">
//               <h3 className="text-base font-bold text-gray-800 flex items-center">
//                 <FiShoppingBag className="mr-2 text-yellow-500" />
//                 Client
//               </h3>
//               <div className="space-y-1 text-sm">
//                 <p className="font-semibold text-gray-800">{invoiceData.client.name}</p>
//                 <p className="text-gray-600">ID: {invoiceData.client.clientId}</p>
//                 {invoiceData.client.phone && (
//                   <p className="text-gray-600 flex items-center">
//                     <FiPhone className="mr-2 text-gray-400 flex-shrink-0" />
//                     {invoiceData.client.phone}
//                   </p>
//                 )}
//                 {invoiceData.client.email && (
//                   <p className="text-gray-600 flex items-center">
//                     <FiMail className="mr-2 text-gray-400 flex-shrink-0" />
//                     {invoiceData.client.email}
//                   </p>
//                 )}
//                 {invoiceData.client.address && (
//                   <p className="text-gray-600 flex items-start">
//                     <FiMapPin className="mr-2 text-gray-400 mt-0.5 flex-shrink-0" />
//                     <span>{invoiceData.client.address}</span>
//                   </p>
//                 )}
//                 <p className="text-gray-600 ml-6">{invoiceData.client.city}</p>
//               </div>
//             </div>
//           </div>

//           {/* Dates et références */}
//           <div className="grid grid-cols-3 gap-4 p-4 bg-gray-50/50 rounded-lg mb-6">
//             <div className="space-y-1">
//               <div className="flex items-center text-gray-600 text-sm">
//                 <FiCalendar className="mr-2 flex-shrink-0" />
//                 <span className="font-medium">Date de commande</span>
//               </div>
//               <p className="font-semibold text-gray-800 text-sm">{invoiceData.header.date}</p>
//             </div>
            
//             <div className="space-y-1">
//               <div className="flex items-center text-gray-600 text-sm">
//                 <FiCalendar className="mr-2 flex-shrink-0" />
//                 <span className="font-medium">Date de livraison</span>
//               </div>
//               <p className="font-semibold text-gray-800 text-sm">{invoiceData.header.dueDate}</p>
//             </div>
            
//             <div className="space-y-1">
//               <div className="flex items-center text-gray-600 text-sm">
//                 <FiFileText className="mr-2 flex-shrink-0" />
//                 <span className="font-medium">Méthode de paiement</span>
//               </div>
//               <p className="font-semibold text-gray-800 text-sm">{invoiceData.summary.paymentMethod}</p>
//               <span className={`text-xs px-2 py-1 rounded-full ${
//                 invoiceData.summary.paymentStatus === 'Payé' 
//                   ? 'bg-green-100 text-green-800' 
//                   : 'bg-yellow-100 text-yellow-800'
//               }`}>
//                 {invoiceData.summary.paymentStatus}
//               </span>
//             </div>
//           </div>

//           {/* Tableau des produits */}
//           <div className="mb-6">
//             <h3 className="text-base font-bold text-gray-800 mb-3">DÉTAIL DES ARTICLES</h3>
            
//             <div className="overflow-x-auto">
//               <table className="min-w-full divide-y divide-gray-200 text-sm">
//                 <thead>
//                   <tr className="bg-gray-50">
//                     <th className="px-4 py-2 text-left font-semibold text-gray-700 uppercase tracking-wider whitespace-nowrap">
//                       Description
//                     </th>
//                     <th className="px-4 py-2 text-left font-semibold text-gray-700 uppercase tracking-wider whitespace-nowrap">
//                       Qté
//                     </th>
//                     <th className="px-4 py-2 text-left font-semibold text-gray-700 uppercase tracking-wider whitespace-nowrap">
//                       Prix unitaire
//                     </th>
//                     <th className="px-4 py-2 text-left font-semibold text-gray-700 uppercase tracking-wider whitespace-nowrap">
//                       Total
//                     </th>
//                   </tr>
//                 </thead>
//                 <tbody className="bg-white divide-y divide-gray-200">
//                   {order.items && order.items.map((item, index) => (
//                     <tr key={index} className="hover:bg-gray-50">
//                       <td className="px-4 py-2">
//                         <div>
//                           <p className="font-medium text-gray-900 text-sm">
//                             {item.product?.name || `Produit ${item.product_id}`}
//                           </p>
//                           {item.product?.description && (
//                             <p className="text-gray-500 mt-0.5 text-xs">
//                               {item.product.description.substring(0, 40)}...
//                             </p>
//                           )}
//                         </div>
//                       </td>
//                       <td className="px-4 py-2 whitespace-nowrap text-center">
//                         <span className="px-2 py-0.5 bg-gray-100 text-gray-800 rounded-full text-sm">
//                           {item.quantity}
//                         </span>
//                       </td>
//                       <td className="px-4 py-2 whitespace-nowrap text-gray-900 font-medium text-sm">
//                         {formatAmount(item.price)} {invoiceData.summary.currency}
//                       </td>
//                       <td className="px-4 py-2 whitespace-nowrap text-gray-900 font-bold text-sm">
//                         {formatAmount(item.price * item.quantity)} {invoiceData.summary.currency}
//                       </td>
//                     </tr>
//                   ))}
                  
//                   {/* Ligne vide pour séparer le total */}
//                   <tr>
//                     <td colSpan="4" className="px-4 py-2 border-t border-gray-300"></td>
//                   </tr>
//                 </tbody>
//               </table>
//             </div>
//           </div>

//           {/* Récapitulatif - POSITION NORMALE */}
//           <div className="flex justify-end mb-6">
//             <div className="w-64 space-y-2 text-sm">
//               <div className="flex justify-between text-gray-600">
//                 <span>Sous-total</span>
//                 <span className="font-medium">{formatAmount(invoiceData.summary.subtotal)} {invoiceData.summary.currency}</span>
//               </div>
              
//               {invoiceData.summary.tax > 0 && (
//                 <div className="flex justify-between text-gray-600">
//                   <span>TVA ({invoiceData.summary.tax}%)</span>
//                   <span className="font-medium">
//                     {formatAmount((invoiceData.summary.subtotal * invoiceData.summary.tax) / 100)} {invoiceData.summary.currency}
//                   </span>
//                 </div>
//               )}
              
//               {invoiceData.summary.shipping > 0 && (
//                 <div className="flex justify-between text-gray-600">
//                   <span>Frais de livraison</span>
//                   <span className="font-medium">{formatAmount(invoiceData.summary.shipping)} {invoiceData.summary.currency}</span>
//                 </div>
//               )}
              
//               <div className="flex justify-between font-bold text-gray-800 pt-3 border-t text-base">
//                 <span>TOTAL</span>
//                 <span className="text-xl text-yellow-600">
//                   {formatAmount(invoiceData.summary.total)} {invoiceData.summary.currency}
//                 </span>
//               </div>
//             </div>
//           </div>

//           {/* Section qui pousse tout vers le bas - ÉLÉMENTS APRÈS LE PRIX TOTAL */}
//           <div className="mt-auto">
//             {/* Signature */}
//             <div className="pt-4 text-left">
//               <div className="grid grid-cols-3 gap-6">  
//                 <div className="mb-2 flex justify-center">
//                   <img 
//                     src={signatureImage} 
//                     alt="Signature directrice" 
//                     className="max-w-[220px] max-h-[150px] object-contain" // Ajustez ces valeurs selon vos besoins
//                     style={{ 
//                       filter: 'grayscale(100%) brightness(0.15) contrast(1.8)'
//                     }} // Optionnel : pour une signature en noir
//                   />
//                 </div>
//                 <div></div>
//                 <div></div>
//               </div>
//               <div className="grid grid-cols-3 gap-6 mb-4">
//                 <div className="inline-block">
//                   <div className="h-0.5 w-24 bg-gray-300 mb-1"></div>
//                   <p className="text-xs text-gray-600">Signature </p>
//                   <p className="text-xs text-gray-500">La Directrice, STELONNE MARKET</p>
//                 </div>
//                 <div> </div>
//                 <div className="inline-block">
//                   <div className="h-0.5 w-24 bg-gray-300 mb-1"></div>
//                   <p className="text-xs text-gray-600">Signature Client</p>
//                   <p className="text-xs text-gray-500">{invoiceData.client.name}</p>
//                 </div>
//               </div>
//             </div>
            
//             {/* Notes et mentions */}
//             <div className="bg-gray-50 p-4 rounded-lg border-t">
//               <div className="grid grid-cols-2 gap-6">
//                 <div>
//                   <h4 className="font-bold text-gray-800 mb-2 text-sm">Conditions de paiement</h4>
//                   <ul className="text-gray-600 space-y-0.5 text-xs">
//                     <li>• Paiement à la livraison</li>
//                     <li>• Pas d'escompte pour paiement anticipé</li>
//                   </ul>
//                 </div>
                
//                 <div>
//                   <h4 className="font-bold text-gray-800 mb-2 text-sm">Informations complémentaires</h4>
//                   <p className="text-gray-600 text-xs">
//                     Merci pour votre confiance. Pour toute pre-occupation, 
//                     veuillez contacter notre service client au {invoiceData.company.phone} 
//                     ou par email à {invoiceData.company.email}
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   // Wrapper pour le responsive (identique à InvoicePreview.jsx)
//   const InvoicePreviewWithWrapper = ({ order }) => {
//     return (
//       <div className="w-full bg-gray-100 p-4">
//         <div className="relative">
//           {/* Version desktop: taille normale */}
//           <div className="hidden md:block">
//             <div className="mx-auto" style={{ maxWidth: '210mm' }}>
//               <InvoiceContent order={order} />
//             </div>
//           </div>
          
//           {/* Version mobile: réduite pour tenir en largeur avec centrage */}
//           <div className="md:hidden">
//             <div className="flex justify-center overflow-x-auto pb-4">
//               <div style={{ 
//                 transform: 'scale(0.40)',
//                 transformOrigin: 'top center',
//                 width: '210mm',
//               }}>
//                 <InvoiceContent order={order} />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   if (loading) {
//     return (
//       <div className="min-h-screen bg-gray-100 flex items-center justify-center">
//         <div className="text-center">
//           <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-yellow-500 mx-auto"></div>
//           <p className="mt-4 text-gray-600">Chargement de la facture...</p>
//         </div>
//       </div>
//     );
//   }

//   if (error || !order) {
//     return (
//       <div className="min-h-screen bg-gray-100 flex items-center justify-center">
//         <div className="text-center">
//           <div className="bg-white p-8 rounded-xl shadow-lg max-w-md">
//             <FiX className="text-5xl text-red-500 mx-auto mb-4" />
//             <h2 className="text-xl font-bold text-gray-800 mb-2">Erreur</h2>
//             <p className="text-gray-600 mb-6">{error || 'Commande non trouvée'}</p>
//             <button
//               onClick={() => navigate('/dashboard/orders')}
//               className="px-6 py-3 bg-yellow-500 text-white rounded-lg font-semibold hover:bg-yellow-600 transition-colors"
//             >
//               Retour aux commandes
//             </button>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen bg-gray-100">
//       {/* En-tête avec navigation */}
//       <div className="bg-white shadow-sm border-b">
//         <div className="max-w-7xl mx-auto px-4 py-4">
//           <div className="flex flex-col md:flex-row md:items-center justify-between">
//             <div className="flex items-center space-x-3 mb-4 md:mb-0">
//               <button
//                 onClick={() => navigate('/dashboard/orders')}
//                 className="flex items-center text-gray-600 hover:text-gray-800 transition-colors"
//               >
//                 <FiArrowLeft className="mr-2" />
//                 Retour
//               </button>
//               <div>
//                 <h1 className="text-xl font-bold text-gray-800">Facture #{order.order_numero}</h1>
//                 <p className="text-sm text-gray-600">
//                   {order.receiver_name} • {order.total_amount.toLocaleString()} FCFA
//                 </p>
//               </div>
//             </div>
            
//             {/* Actions principales */}
//             <div className="flex flex-wrap gap-2">
//               <button
//                 onClick={printInvoice}
//                 className="flex items-center px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
//               >
//                 <FiPrinter className="mr-2" />
//                 Imprimer
//               </button>
              
//               <button
//                 onClick={generatePDF}
//                 disabled={generatingPDF}
//                 className="flex items-center px-4 py-2 bg-yellow-500 text-white rounded-lg hover:bg-yellow-600 transition-colors disabled:opacity-50"
//               >
//                 {generatingPDF ? (
//                   <>
//                     <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
//                     Génération PDF...
//                   </>
//                 ) : (
//                   <>
//                     <FiDownload className="mr-2" />
//                     Télécharger PDF
//                   </>
//                 )}
//               </button>
              
//               <button
//                 onClick={() => setShowWhatsAppForm(true)}
//                 className="flex items-center px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
//               >
//                 <FiSend className="mr-2" />
//                 Envoyer WhatsApp
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Contenu principal - Facture */}
//       <InvoicePreviewWithWrapper order={order} />

//       {/* Modal WhatsApp */}
//       {showWhatsAppForm && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
//           <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md">
//             <div className="p-6">
//               <div className="flex items-center justify-between mb-6">
//                 <div className="flex items-center">
//                   <div className="bg-green-100 text-green-600 p-2 rounded-lg mr-3">
//                     <FiSend className="text-xl" />
//                   </div>
//                   <div>
//                     <h3 className="text-lg font-bold text-gray-800">Envoyer par WhatsApp</h3>
//                     <p className="text-sm text-gray-600">Client: {order.receiver_name}</p>
//                   </div>
//                 </div>
//                 <button
//                   onClick={() => setShowWhatsAppForm(false)}
//                   className="text-gray-400 hover:text-gray-600"
//                 >
//                   <FiX className="text-xl" />
//                 </button>
//               </div>

//               <div className="space-y-4">
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-2">
//                     Numéro WhatsApp
//                   </label>
//                   <div className="flex items-center">
//                     <div className="bg-gray-100 text-gray-500 px-3 py-2 rounded-l-lg border border-r-0 border-gray-300">
//                       +237
//                     </div>
//                     <input
//                       type="tel"
//                       value={whatsappNumber}
//                       onChange={(e) => setWhatsappNumber(e.target.value)}
//                       className="flex-1 px-3 py-2 border border-gray-300 rounded-r-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
//                       placeholder="6XX XXX XXX"
//                     />
//                   </div>
//                   <p className="text-xs text-gray-500 mt-1">
//                     Le numéro sera utilisé pour envoyer la facture via WhatsApp
//                   </p>
//                 </div>

//                 <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
//                   <div className="flex items-start">
//                     <FiCheck className="text-blue-600 mt-0.5 mr-2" />
//                     <div>
//                       <p className="text-sm text-blue-800 font-medium">Information</p>
//                       <p className="text-xs text-blue-700 mt-1">
//                         Le message WhatsApp s'ouvrira dans une nouvelle fenêtre.
//                       </p>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               <div className="flex justify-end space-x-3 mt-6">
//                 <button
//                   onClick={() => setShowWhatsAppForm(false)}
//                   className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
//                 >
//                   Annuler
//                 </button>
//                 <button
//                   onClick={sendViaWhatsApp}
//                   disabled={sendingWhatsApp || !whatsappNumber.trim()}
//                   className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors disabled:opacity-50 flex items-center"
//                 >
//                   {sendingWhatsApp ? (
//                     <>
//                       <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
//                       Préparation...
//                     </>
//                   ) : (
//                     <>
//                       <FiSend className="mr-2" />
//                       Ouvrir WhatsApp
//                     </>
//                   )}
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default InvoicePage;

// src/pages/InvoicePage.jsx
import signatureImage from '../assets/signn-removebg-preview.png';
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { 
  FiArrowLeft, 
  FiDownload, 
  FiSend, 
  FiPrinter, 
  FiCheck, 
  FiX,
  FiShoppingBag, 
  FiMapPin, 
  FiPhone, 
  FiMail,
  FiCalendar,
  FiFileText
} from 'react-icons/fi';
import { orderAPI } from '../services/api';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

const InvoicePage = () => {
  const { orderId } = useParams();
  console.log("l'id de la commande est", orderId);
  const navigate = useNavigate();
  const location = useLocation();

  // Récupérer le paramètre newLivre depuis l'URL
  const queryParams = new URLSearchParams(location.search);
  console.log("recuperation de la requette")
  console.log(queryParams);
  const newLivre = queryParams.get('newLivre');
  console.log("voici le prix de la livraison")
  console.log(newLivre);
  
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [generatingPDF, setGeneratingPDF] = useState(false);
  const [showWhatsAppForm, setShowWhatsAppForm] = useState(false);
  const [whatsappNumber, setWhatsappNumber] = useState('');
  const [sendingWhatsApp, setSendingWhatsApp] = useState(false);
  // Ajoute un état pour savoir si l'image du filigrane est chargée
  const [watermarkLoaded, setWatermarkLoaded] = useState(false);

  // Récupérer les détails de la commande
  useEffect(() => {
    const fetchOrderDetails = async () => {
      try {
        setLoading(true);
        const response = await orderAPI.getMyOrders(orderId);
        
        if (response.data && response.data.success) {
          const orderData = response.data.data;
          
          const formattedOrder = {
            id: orderData.id,
            order_numero: orderData.order_number || `CMD-${orderData.id}`,
            user_id: orderData.user_id,
            receiver_name: orderData.recipient_name || orderData.shipping_name,
            receiver_phone: orderData.recipient_phone || orderData.shipping_phone,
            receiver_email: orderData.recipient_email || orderData.user?.email,
            receiver_address: orderData.recipient_address || orderData.shipping_address,
            receiver_city: orderData.recipient_city || orderData.shipping_city,
            receiver_country: orderData.recipient_country || orderData.shipping_country,
            status: orderData.status,
            total_amount: orderData.total_amount || 0,
            created_at: orderData.created_at || new Date().toISOString(),
            updated_at: orderData.updated_at || new Date().toISOString(),
            items: orderData.items || orderData.order_items || []
          };
          
          setOrder(formattedOrder);
          
          if (formattedOrder.receiver_phone) {
            setWhatsappNumber(formattedOrder.receiver_phone);
          }
        } else {
          setError('Commande non trouvée');
        }
      } catch (err) {
        console.error('Erreur lors du chargement de la commande:', err);
        setError('Impossible de charger les détails de la commande');
      } finally {
        setLoading(false);
      }
    };

    if (orderId) {
      fetchOrderDetails();
    }
  }, [orderId]);

  // calcule du veritable total de la commande
  const getTotalOrder = (items) => {
    return items.reduce((accumulator, item) => {
      const itemTotal = item.price * item.quantity;
      return accumulator + itemTotal;
    }, 0);
  }

  // Formatage des données pour la facture
  const getInvoiceData = () => {
    if (!order) return null;
    
    return {
      header: {
        logo: 'StelonneMarket',
        title: 'FACTURE',
        invoiceNumber: order.order_numero || `CMD-${order.id}`,
        date: new Date(order.created_at).toLocaleDateString('fr-FR', {
          day: '2-digit',
          month: 'long',
          year: 'numeric'
        }),
        dueDate: new Date(order.updated_at).toLocaleDateString('fr-FR', {
          day: '2-digit',
          month: 'long',
          year: 'numeric'
        })
      },
      company: {
        name: 'STELONE MARKET SARL',
        address: 'Commissariat 14e, Ndogpassi II',
        city: 'Douala, Cameroun',
        phone: '+237 (680 219 057 / 655 996 918) ',
        email: 'contact@stelonne-market.online',
        url: 'www.stelonne-market.online',
        // rccm: 'RCCM-DLA-2024-XXXX',
        nui: 'P019318559728M'
      },
      client: {
        name: order.receiver_name || 'Client',
        phone: order.receiver_phone,
        email: order.receiver_email,
        address: order.receiver_address,
        city: `${order.receiver_city || ''}${order.receiver_city && order.receiver_country ? ', ' : ''}${order.receiver_country || ''}`,
        clientId: `CLT-${order.user_id || '000'}`
      },
      summary: {
        totalTrue: parseInt(getTotalOrder(order.items)),
        reduction: parseInt(getTotalOrder(order.items)) - parseInt(order.total_amount),
        subtotal: order.total_amount,
        tax: 0,
        shipping: newLivre ? parseFloat(newLivre) : 5000,
        total: parseInt(order.total_amount) + (newLivre ? parseInt(newLivre) : 5000),
        currency: 'FCFA',
        paymentMethod: 'Cash on Delivery',
        paymentStatus: order.status === 'completed' ? 'Payé' : 'En attente'
      }
    };
  };

  // Formater le montant
  const formatAmount = (amount) => {
    return new Intl.NumberFormat('fr-FR').format(amount);
  };

  // Générer le PDF
  const generatePDF = async () => {
    if (!order) return;
    
    setGeneratingPDF(true);
    try {
      const invoiceElement = document.getElementById('invoice-to-print');
      
      if (!invoiceElement) {
        throw new Error('Élément de facture non trouvé');
      }

      // Attendre que l'image du filigrane soit chargée
      const watermarkImage = invoiceElement.querySelector('.opacity-10 img');
      if (watermarkImage && !watermarkImage.complete) {
        console.log('⏳ Attente du chargement de l\'image du filigrane...');
        await new Promise((resolve) => {
          watermarkImage.onload = resolve;
          watermarkImage.onerror = resolve;
        });
        console.log('✅ Image du filigrane chargée');
      }
      
      // Attendre que TOUTES les images soient chargées (optionnel mais recommandé)
      const allImages = invoiceElement.querySelectorAll('img');
      await Promise.all(Array.from(allImages).map(img => {
        if (img.complete) return Promise.resolve();
        return new Promise((resolve) => {
          img.onload = resolve;
          img.onerror = resolve;
        });
      }));

      // === NOUVEAU CODE : Cloner et traiter les images ===
      const clone = invoiceElement.cloneNode(true);
      
      // Fonction pour appliquer le filtre à la signature
      const processSignatureImage = async () => {
        const signatureImg = clone.querySelector('img[alt="Signature directrice"]');
        
        if (!signatureImg || !signatureImg.src) return;
        
        return new Promise((resolve) => {
          const tempImg = new Image();
          tempImg.crossOrigin = "anonymous";
          
          tempImg.onload = () => {
            // Créer un canvas pour appliquer le filtre
            const tempCanvas = document.createElement('canvas');
            const ctx = tempCanvas.getContext('2d');
            
            tempCanvas.width = tempImg.width;
            tempCanvas.height = tempImg.height;
            
            // Appliquer le filtre noir
            ctx.filter = 'grayscale(100%) brightness(0.15) contrast(1.8)';
            ctx.drawImage(tempImg, 0, 0);
            
            // Remplacer la source de l'image dans le clone
            signatureImg.src = tempCanvas.toDataURL('image/png');
            signatureImg.style.filter = 'none'; // Retirer le filtre CSS
            
            resolve();
          };
          
          tempImg.onerror = () => {
            console.warn('Erreur de chargement de la signature');
            resolve();
          };
          
          tempImg.src = signatureImg.src;
        });
      };
      
      // Appliquer le traitement à la signature
      await processSignatureImage();
      
      // Ajouter le clone temporairement au DOM
      clone.style.position = 'absolute';
      clone.style.left = '-9999px';
      clone.style.top = '0';
      document.body.appendChild(clone);
      
      // Dimensions A4
      const PDF_WIDTH = 210; // mm
      const PDF_HEIGHT = 297; // mm
      const MARGIN = 10; // mm sur chaque côté
      const USABLE_HEIGHT = PDF_HEIGHT - (2 * MARGIN);

      // D'abord essayer avec l'échelle normale
      let scale = 2;
      let canvas = await html2canvas(clone, { // Utiliser le clone au lieu de l'original
        scale: scale,
        useCORS: true,
        backgroundColor: '#ffffff',
        width: clone.scrollWidth,
        height: clone.scrollHeight,
        onclone: (clonedDoc) => {
          // S'assurer que les styles sont conservés
          const clonedSignature = clonedDoc.querySelector('img[alt="Signature directrice"]');
          if (clonedSignature && clonedSignature.style.filter === 'none') {
            clonedSignature.style.filter = 'grayscale(100%) brightness(0.15) contrast(1.8)';
          }
        }
      });

      // Nettoyer : retirer le clone du DOM
      document.body.removeChild(clone);

      // Calculer la hauteur en mm
      const imgHeightMm = (canvas.height * (PDF_WIDTH - 2 * MARGIN)) / canvas.width;
      
      // Si le contenu dépasse légèrement (moins de 20mm)
      const OVERFLOW_THRESHOLD = 20; // mm
      if (imgHeightMm > USABLE_HEIGHT && imgHeightMm <= USABLE_HEIGHT + OVERFLOW_THRESHOLD) {
        // Réduire légèrement l'échelle pour tout faire tenir sur une page
        const compressionRatio = USABLE_HEIGHT / imgHeightMm;
        scale = scale * compressionRatio * 0.95; // 95% pour une marge
        
        // Regénérer le canvas avec la nouvelle échelle
        canvas = await html2canvas(clone, {
          scale: scale,
          useCORS: true,
          backgroundColor: '#ffffff',
          width: clone.scrollWidth,
          height: clone.scrollHeight
        });
      }

      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'a4'
      });

      const imgWidth = PDF_WIDTH - 2 * MARGIN;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      const xPos = MARGIN;
      const yPos = MARGIN;

      // Vérifier si besoin de plusieurs pages après compression
      if (imgHeight <= USABLE_HEIGHT) {
        // Tout tient sur une page
        pdf.addImage(imgData, 'PNG', xPos, yPos, imgWidth, imgHeight);
      } else {
        // Nécessite plusieurs pages
        let currentY = 0;
        let pageNum = 0;
        
        while (currentY < imgHeight) {
          if (currentY > 0) {
            pdf.addPage();
            pageNum++;
          }
          
          const sliceHeight = Math.min(USABLE_HEIGHT, imgHeight - currentY);
          
          // Créer un canvas pour la tranche
          const sliceCanvas = document.createElement('canvas');
          const sliceCtx = sliceCanvas.getContext('2d');
          const sliceYCanvas = (currentY / imgHeight) * canvas.height;
          const sliceHeightCanvas = (sliceHeight / imgHeight) * canvas.height;
          
          sliceCanvas.width = canvas.width;
          sliceCanvas.height = sliceHeightCanvas;
          
          sliceCtx.drawImage(
            canvas,
            0, sliceYCanvas, canvas.width, sliceHeightCanvas,
            0, 0, canvas.width, sliceHeightCanvas
          );
          
          const sliceData = sliceCanvas.toDataURL('image/png');
          pdf.addImage(sliceData, 'PNG', xPos, yPos, imgWidth, sliceHeight);
          
          // Pied de page
          pdf.setFontSize(8);
          pdf.setTextColor(150);
          pdf.text(
            `Page ${pageNum + 1} - Facture ${order.order_numero}`,
            PDF_WIDTH / 2,
            PDF_HEIGHT - 5,
            { align: 'center' }
          );
          
          currentY += sliceHeight;
        }
      }

      const fileName = `Facture_${order.order_numero}_${new Date().toISOString().split('T')[0]}.pdf`;
      pdf.save(fileName);
      
    } catch (error) {
      console.error('Erreur génération PDF:', error);
      alert('Erreur lors de la génération du PDF');
    } finally {
      setGeneratingPDF(false);
    }
  };

  // Envoyer par WhatsApp
  const sendViaWhatsApp = () => {
    if (!whatsappNumber.trim()) {
      alert('Veuillez entrer un numéro WhatsApp valide');
      return;
    }

    const formattedNumber = whatsappNumber
      .replace(/\s+/g, '')
      .replace('+', '')
      .replace(/^0/, '237');

    const message = encodeURIComponent(
      `Bonjour ${order.receiver_name},\n\nVotre facture pour la commande ${order.order_numero} est prête.\nMontant total: ${order.total_amount.toLocaleString()} FCFA\n\nMerci pour votre confiance !\n\nStellone Market`
    );

    const whatsappURL = `https://wa.me/${formattedNumber}?text=${message}`;
    
    window.open(whatsappURL, '_blank');
    
    setSendingWhatsApp(true);
    setTimeout(() => {
      setSendingWhatsApp(false);
      setShowWhatsAppForm(false);
      alert('Message WhatsApp préparé ! Ouvrez WhatsApp pour envoyer.');
    }, 1500);
  };

  // Imprimer la facture
  const printInvoice = () => {
    const invoiceElement = document.getElementById('invoice-to-print');
    
    if (!invoiceElement) return;
    
    const printWindow = window.open('', '_blank');
    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>Facture ${order.order_numero}</title>
          <style>
            @page {
              margin: 10mm;
            }
            body {
              margin: 0;
              padding: 0;
            }
          </style>
        </head>
        <body>
          ${invoiceElement.outerHTML}
        </body>
      </html>
    `);
    
    printWindow.document.close();
    
    setTimeout(() => {
      printWindow.focus();
      printWindow.print();
      printWindow.close();
    }, 300);
  };

  // Composant de facture
  const InvoiceContent = ({ order }) => {
    const invoiceData = getInvoiceData();
    
    if (!invoiceData) return null;
    
    return (
      <div 
        id="invoice-to-print" 
        className="bg-white shadow-2xl overflow-hidden relative mx-auto"
        style={{
          width: '210mm',
          minHeight: '297mm',
          boxSizing: 'border-box'
        }}
      >
        {/* Filigrane "STELLONE MARKET" sur l'autre diagonale (de haut droit à bas gauche) - STATIQUE */}
        {/* <div className="absolute inset-0 overflow-hidden pointer-events-none z-0">
          <div 
            className="absolute w-[150%]"
            style={{
              top: '-7%',
              right: '0',
              transform: 'rotate(-45deg) translateX(30%) translateY(-50%)',
              transformOrigin: 'top right',
            }}
          >
            <div 
              className="text-yellow-300/20 font-bold whitespace-nowrap tracking-wider"
              style={{
                fontSize: '70px', // Taille réduite pour que tout tienne dans la page
                lineHeight: '1',
                textShadow: '2px 2px 4px rgba(0,0,0,0.1)',
                letterSpacing: '10px',
              }}
            >
              STELONNE
            </div>
          </div> */}
          
          {/* Deuxième occurrence pour couvrir toute la diagonale */}
          {/* <div 
            className="absolute w-[150%]"
            style={{
              top: '34%',
              right: '-9%',
              transform: 'rotate(-45deg) translateX(30%) translateY(-50%)',
              transformOrigin: 'top right',
            }}
          >
            <div 
              className="text-yellow-300/20 font-bold whitespace-nowrap tracking-wider"
              style={{
                fontSize: '70px',
                lineHeight: '1',
                textShadow: '2px 2px 4px rgba(0,0,0,0.1)',
                letterSpacing: '10px',
              }}
            >
              MARKET
            </div>
          </div>
        </div> */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none z-0 flex items-center justify-center">
          <div className="opacity-10 transform scale-150">
            <img 
              src="/logo512.png" 
              alt="Stellone Market" 
              className="w-64 h-auto object-contain"
              onLoad={() => setWatermarkLoaded(true)}
              style={{
                filter: 'grayscale(100%) brightness(0.5) sepia(1) hue-rotate(-10deg) saturate(3)',
              }}
            />
          </div>
        </div>

        <div className="p-1 relative z-10 flex flex-col" style={{ 
          boxSizing: 'border-box',
          minHeight: '297mm'
        }}>
          
          {/* En-tête de la facture */}
          <div className="bg-gradient-to-r from-yellow-400 to-yellow-400 p-4 text-white rounded-lg mb-6">
            <div className="flex justify-between items-start">
              <div className="flex items-center space-x-3">
                {/* Logo avec encadrement gris et ombre */}
                <div className="bg-white p-2 rounded-lg shadow-lg border border-gray-200 hover:shadow-xl transition-shadow duration-300">
                  <img 
                    src="/logo192.png" 
                    alt="Stellone Market" 
                    className="h-10 w-auto object-contain"
                  />
                </div>
                <div>
                  <h1 className="text-2xl font-bold leading-tight">STELONNE MARKET</h1>
                  <p className="text-yellow-100 text-sm mt-1">Decouvrez & Achetez & Profitez</p>
                </div>
              </div>
              
              <div className="text-right bg-gray-400/100 p-3 rounded-lg">
                <h2 className="text-xl font-bold text-white mb-1">FACTURE</h2>
                <p className="text-yellow-100 text-sm">N° {invoiceData.header.invoiceNumber}</p>
              </div>
            </div>
          </div>

          {/* Informations entreprise et client */}
          <div className="grid grid-cols-2 gap-6 mb-6">
            {/* Informations entreprise */}
            <div className="space-y-2">
              <h3 className="text-base font-bold text-gray-800 flex items-center">
                <FiShoppingBag className="mr-2 text-yellow-500" />
                Societe
              </h3>
              <div className="space-y-1 text-sm">
                <p className="font-bold text-gray-800">{invoiceData.company.name}</p>
                <p className="text-gray-600 flex items-start">
                  {/* <FiMapPin className="mr-2 text-gray-400 mt-1 mb-0.5 flex-shrink-0" /> */}
                  <span className="font-semibold text-gray-800">Addresse </span>
                  <span className="pt-0">: {invoiceData.company.address}</span>
                </p>
                <p className="text-gray-600 ml-16">{invoiceData.company.city}</p>
                <p className="text-gray-600 flex items-center">
                  {/* <FiPhone className="mr-2 text-gray-400 flex-shrink-0" /> */}
                  <span className="font-semibold text-gray-800">Tel </span>
                  <span className="ml-11">: {invoiceData.company.phone}</span>
                </p>
                <p className="text-gray-600 flex items-center">
                  {/* <FiPhone className="mr-2 text-gray-400 flex-shrink-0" /> */}
                  <span className="font-semibold text-gray-800">Web_site </span>
                  <span className="ml-1">: {invoiceData.company.url}</span>
                </p>
                <p className="text-gray-600 flex items-center">
                  {/* <FiMail className="mr-2 text-gray-400 flex-shrink-0" /> */}
                  <span className="font-semibold text-gray-800">Email </span>
                  <span className="ml-7">: {invoiceData.company.email}</span>
                </p>
                <div className="flex space-x-2 mt-1">
                  {/* <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded">
                    {invoiceData.company.rccm}
                  </span> */}
                  <span className="font-semibold text-gray-800 mr-5">NIU </span>
                  <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded">
                    : {invoiceData.company.nui}
                  </span>
                </div>
              </div>
            </div>

            {/* Informations client */}
            <div className="space-y-2">
              <h3 className="text-base font-bold text-gray-800 flex items-center">
                <FiShoppingBag className="mr-2 text-yellow-500" />
                Client
              </h3>
              <div className="space-y-1 text-sm">
                <p className="font-semibold text-gray-800">{invoiceData.client.name}</p>
                <p className="text-gray-600">ID: {invoiceData.client.clientId}</p>
                {invoiceData.client.phone && (
                  <p className="text-gray-600 flex items-center">
                    {/* <FiPhone className="mr-2 text-gray-400 flex-shrink-0 mt-1" /> */}
                    Tel : {invoiceData.client.phone}
                  </p>
                )}
                {invoiceData.client.email && (
                  <p className="text-gray-600 flex items-center">
                    {/* <FiMail className="mr-2 text-gray-400 flex-shrink-0 mt-1" /> */}
                    Email : {invoiceData.client.email}
                  </p>
                )}
                {invoiceData.client.address && (
                  <p className="text-gray-600 flex items-start">
                    {/* <FiMapPin className="mr-2 text-gray-400 mt-0.5 flex-shrink-0 mt-1" /> */}
                    <span>Adresse : {invoiceData.client.address}</span>
                  </p>
                )}
                <p className="text-gray-600 ml-14">{invoiceData.client.city}</p>
              </div>
            </div>
          </div>

          {/* Dates et références */}
          <div className="grid grid-cols-3 gap-4 p-4 bg-gray-50/50 rounded-lg mb-6">
            <div className="space-y-1">
              <div className="flex items-center text-gray-600 text-sm">
                <FiCalendar className="mr-2 flex-shrink-0" />
                <span className="font-medium">Date de commande</span>
              </div>
              <p className="font-semibold text-gray-800 text-sm">{invoiceData.header.date}</p>
            </div>
            
            <div className="space-y-1">
              <div className="flex items-center text-gray-600 text-sm">
                <FiCalendar className="mr-2 flex-shrink-0" />
                <span className="font-medium">Date de livraison</span>
              </div>
              <p className="font-semibold text-gray-800 text-sm">{invoiceData.header.dueDate}</p>
            </div>
            
            <div className="space-y-1">
              <div className="flex items-center text-gray-600 text-sm">
                <FiFileText className="mr-2 flex-shrink-0" />
                <span className="font-medium">Méthode de paiement</span>
              </div>
              <p className="font-semibold text-gray-800 text-sm">{invoiceData.summary.paymentMethod}</p>
              <span className={`text-xs px-2 py-1 rounded-full ${
                invoiceData.summary.paymentStatus === 'Payé' 
                  ? 'bg-green-100 text-green-800' 
                  : 'bg-yellow-100 text-yellow-800'
              }`}>
                {invoiceData.summary.paymentStatus}
              </span>
            </div>
          </div>

          {/* Tableau des produits */}
          <div className="mb-6">
            <h3 className="text-base font-bold text-gray-800 mb-3">DÉTAIL DES ARTICLES</h3>
            
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200/50 text-sm">
                <thead className="bg-gray-900/50">
                  <tr className="bg-gray-50/50">
                    <th className="px-4 py-2 text-left font-semibold text-gray-800 uppercase tracking-wider whitespace-nowrap">
                      Description
                    </th>
                    <th className="px-4 py-2 text-left font-semibold text-gray-700 uppercase tracking-wider whitespace-nowrap">
                      Qté
                    </th>
                    <th className="px-4 py-2 text-left font-semibold text-gray-700 uppercase tracking-wider whitespace-nowrap">
                      Prix unitaire
                    </th>
                    <th className="px-4 py-2 text-left font-semibold text-gray-700 uppercase tracking-wider whitespace-nowrap">
                      Total
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white/50 divide-y divide-gray-200">
                  {order.items && order.items.map((item, index) => (
                    <tr key={index} className="hover:bg-gray-50/50">
                      <td className="px-4 py-2">
                        <div>
                          <p className="font-medium text-gray-900 text-sm">
                            {item.product?.name || `Produit ${item.product_id}`}
                          </p>
                          {item.product?.description && (
                            <p className="text-gray-500 mt-0.5 text-xs">
                              {item.product.description.substring(0, 40)}...
                            </p>
                          )}
                        </div>
                      </td>
                      <td className="px-4 py-2 whitespace-nowrap text-center">
                        <span className="px-2 py-0.5 bg-gray-100 text-gray-800 rounded-full text-sm">
                          {item.quantity}
                        </span>
                      </td>
                      <td className="px-4 py-2 whitespace-nowrap text-gray-900 font-medium text-sm">
                        {formatAmount(item.price)} {invoiceData.summary.currency}
                      </td>
                      <td className="px-4 py-2 whitespace-nowrap text-gray-900 font-bold text-sm">
                        {formatAmount(item.price * item.quantity)} {invoiceData.summary.currency}
                      </td>
                    </tr>
                  ))}
                  
                  {/* Ligne vide pour séparer le total */}
                  <tr>
                    <td colSpan="4" className="px-4 py-2 border-t border-gray-300"></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Récapitulatif - POSITION NORMALE */}
          <div className="flex justify-end mb-6">
            <div className="w-64 space-y-2 text-sm">
              {invoiceData.summary.totalTrue != invoiceData.summary.subtotal && (
                <>
                  <div className="flex justify-between text-gray-600">
                    <span>Total initial </span>
                    <span className="font-medium">{formatAmount(invoiceData.summary.totalTrue)} {invoiceData.summary.currency}</span>
                  </div>

                  <div className="flex justify-between text-gray-600">
                    <span>Reduction</span>
                    <span className="font-medium">{formatAmount(invoiceData.summary.reduction)} {invoiceData.summary.currency}</span>
                  </div>
                </>
              )}

              <div className="flex justify-between text-gray-600">
                <span>Sous-total</span>
                <span className="font-medium">{formatAmount(invoiceData.summary.subtotal)} {invoiceData.summary.currency}</span>
              </div>
              
              {invoiceData.summary.tax > 0 && (
                <div className="flex justify-between text-gray-600">
                  <span>TVA ({invoiceData.summary.tax}%)</span>
                  <span className="font-medium">
                    {formatAmount((invoiceData.summary.subtotal * invoiceData.summary.tax) / 100)} {invoiceData.summary.currency}
                  </span>
                </div>
              )}
              
              {invoiceData.summary.shipping > 0 && (
                <div className="flex justify-between text-gray-600">
                  <span>Frais de livraison</span>
                  <span className="font-medium">{formatAmount(invoiceData.summary.shipping)} {invoiceData.summary.currency}</span>
                </div>
              )}
              
              <div className="flex justify-between font-bold text-gray-800 pt-3 border-t text-base">
                <span>TOTAL</span>
                <span className="text-xl text-yellow-600">
                  {formatAmount(invoiceData.summary.total)} {invoiceData.summary.currency}
                </span>
              </div>
            </div>
          </div>

          {/* Section qui pousse tout vers le bas - ÉLÉMENTS APRÈS LE PRIX TOTAL */}
          <div className="mt-auto">
            {/* Signature */}
            <div className="pt-4 text-left">
              <div className="grid grid-cols-3 gap-6">  
                <div className="mb-2 flex justify-center">
                  <img 
                    src={signatureImage} 
                    alt="Signature directrice" 
                    className="max-w-[220px] max-h-[150px] object-contain" // Ajustez ces valeurs selon vos besoins
                    style={{ 
                      filter: 'grayscale(100%) brightness(0.15) contrast(1.8)'
                    }} // Optionnel : pour une signature en noir
                  />
                </div>
                <div></div>
                <div></div>
              </div>
              <div className="grid grid-cols-3 gap-6 mb-4">
                <div className="inline-block">
                  <div className="h-0.5 w-24 bg-gray-300 mb-1"></div>
                  <p className="text-xs text-gray-600">Signature </p>
                  <p className="text-xs text-gray-500">La Directrice, STELONNE MARKET</p>
                </div>
                <div> </div>
                <div className="inline-block">
                  <div className="h-0.5 w-24 bg-gray-300 mb-1"></div>
                  <p className="text-xs text-gray-600">Signature Client</p>
                  <p className="text-xs text-gray-500">{invoiceData.client.name}</p>
                </div>
              </div>
            </div>
            
            {/* Notes et mentions */}
            <div className="bg-gray-50 p-4 rounded-lg border-t">
              <div className="grid grid-cols-2 gap-6">
                <div>
                  <h4 className="font-bold text-gray-800 mb-2 text-sm">Conditions de paiement</h4>
                  <ul className="text-gray-600 space-y-0.5 text-xs">
                    <li>• Paiement à la livraison</li>
                    <li>• Pas d'escompte pour paiement anticipé</li>
                  </ul>
                </div>
                
                <div>
                  <h4 className="font-bold text-gray-800 mb-2 text-sm">Informations complémentaires</h4>
                  <p className="text-gray-600 text-xs">
                    Merci pour votre confiance. Pour toute pre-occupation, 
                    veuillez contacter notre service client au {invoiceData.company.phone} 
                    ou par email à {invoiceData.company.email}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Wrapper pour le responsive (identique à InvoicePreview.jsx)
  const InvoicePreviewWithWrapper = ({ order }) => {
    return (
      <div className="w-full bg-gray-100 p-4">
        <div className="relative">
          {/* Version desktop: taille normale */}
          <div className="hidden md:block">
            <div className="mx-auto" style={{ maxWidth: '210mm' }}>
              <InvoiceContent order={order} />
            </div>
          </div>
          
          {/* Version mobile: réduite pour tenir en largeur avec centrage */}
          <div className="md:hidden">
            <div className="flex justify-center overflow-x-auto pb-4">
              <div style={{ 
                transform: 'scale(0.40)',
                transformOrigin: 'top center',
                width: '210mm',
              }}>
                <InvoiceContent order={order} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-yellow-500 mx-auto"></div>
          <p className="mt-4 text-gray-600">Chargement de la facture...</p>
        </div>
      </div>
    );
  }

  if (error || !order) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="text-center">
          <div className="bg-white p-8 rounded-xl shadow-lg max-w-md">
            <FiX className="text-5xl text-red-500 mx-auto mb-4" />
            <h2 className="text-xl font-bold text-gray-800 mb-2">Erreur</h2>
            <p className="text-gray-600 mb-6">{error || 'Commande non trouvée'}</p>
            <button
              onClick={() => navigate('/dashboard/orders')}
              className="px-6 py-3 bg-yellow-500 text-white rounded-lg font-semibold hover:bg-yellow-600 transition-colors"
            >
              Retour aux commandes
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100">
      {/* En-tête avec navigation */}
      <div className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 py-4">
          <div className="flex flex-col md:flex-row md:items-center justify-between">
            <div className="flex items-center space-x-3 mb-4 md:mb-0">
              <button
                onClick={() => navigate('/dashboard/orders')}
                className="flex items-center text-gray-600 hover:text-gray-800 transition-colors"
              >
                <FiArrowLeft className="mr-2" />
                Retour
              </button>
              <div>
                <h1 className="text-xl font-bold text-gray-800">Facture #{order.order_numero}</h1>
                <p className="text-sm text-gray-600">
                  {order.receiver_name} • {order.total_amount.toLocaleString()} FCFA
                </p>
              </div>
            </div>
            
            {/* Actions principales */}
            <div className="flex flex-wrap gap-2">
              <button
                onClick={printInvoice}
                className="flex items-center px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
              >
                <FiPrinter className="mr-2" />
                Imprimer
              </button>
              
              <button
                onClick={generatePDF}
                disabled={generatingPDF}
                className="flex items-center px-4 py-2 bg-yellow-500 text-white rounded-lg hover:bg-yellow-600 transition-colors disabled:opacity-50"
              >
                {generatingPDF ? (
                  <>
                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                    Génération PDF...
                  </>
                ) : (
                  <>
                    <FiDownload className="mr-2" />
                    Télécharger PDF
                  </>
                )}
              </button>
              
              <button
                onClick={() => setShowWhatsAppForm(true)}
                className="flex items-center px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
              >
                <FiSend className="mr-2" />
                Envoyer WhatsApp
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Contenu principal - Facture */}
      <InvoicePreviewWithWrapper order={order} />

      {/* Modal WhatsApp */}
      {showWhatsAppForm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md">
            <div className="p-6">
              <div className="flex items-center justify-between mb-6">
                <div className="flex items-center">
                  <div className="bg-green-100 text-green-600 p-2 rounded-lg mr-3">
                    <FiSend className="text-xl" />
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-800">Envoyer par WhatsApp</h3>
                    <p className="text-sm text-gray-600">Client: {order.receiver_name}</p>
                  </div>
                </div>
                <button
                  onClick={() => setShowWhatsAppForm(false)}
                  className="text-gray-400 hover:text-gray-600"
                >
                  <FiX className="text-xl" />
                </button>
              </div>

              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Numéro WhatsApp
                  </label>
                  <div className="flex items-center">
                    <div className="bg-gray-100 text-gray-500 px-3 py-2 rounded-l-lg border border-r-0 border-gray-300">
                      +237
                    </div>
                    <input
                      type="tel"
                      value={whatsappNumber}
                      onChange={(e) => setWhatsappNumber(e.target.value)}
                      className="flex-1 px-3 py-2 border border-gray-300 rounded-r-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                      placeholder="6XX XXX XXX"
                    />
                  </div>
                  <p className="text-xs text-gray-500 mt-1">
                    Le numéro sera utilisé pour envoyer la facture via WhatsApp
                  </p>
                </div>

                <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                  <div className="flex items-start">
                    <FiCheck className="text-blue-600 mt-0.5 mr-2" />
                    <div>
                      <p className="text-sm text-blue-800 font-medium">Information</p>
                      <p className="text-xs text-blue-700 mt-1">
                        Le message WhatsApp s'ouvrira dans une nouvelle fenêtre.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex justify-end space-x-3 mt-6">
                <button
                  onClick={() => setShowWhatsAppForm(false)}
                  className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
                >
                  Annuler
                </button>
                <button
                  onClick={sendViaWhatsApp}
                  disabled={sendingWhatsApp || !whatsappNumber.trim()}
                  className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors disabled:opacity-50 flex items-center"
                >
                  {sendingWhatsApp ? (
                    <>
                      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                      Préparation...
                    </>
                  ) : (
                    <>
                      <FiSend className="mr-2" />
                      Ouvrir WhatsApp
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default InvoicePage;